<template>
  <div class="alert-container" v-if="message">
    <div :class="[alertTypeClass]" class="rounded-md bg-opacity-90 p-4">
      <div class="flex items-center space-x-4">
        <div class="flex-shrink-0">
          <svg
            v-if="alertType === 'success'"
            class="h-5 w-5 text-green-400"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="flex-grow ml-3 text-sm font-medium">{{ message }}</div>
        <div>
          <button
            v-if="alertType === 'dismiss' || alertType === 'success'"
            type="button"
            @click="dismissAlert"
            class="text-gray-400 hover:text-gray-600 focus:outline-none"
            aria-label="Close"
          >
            <svg class="h-8 w-8" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeoutId: null,
    };
  },
  props: {
    message: {
      type: String,
      required: true,
    },
    alertType: {
      type: String,
      required: true,
    },
  },
  watch: {
    alertType: {
      handler() {
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(this.dismissAlert, 5000);
      },
      immediate: true,
    },
  },
  computed: {
    alertTypeClass() {
      return {
        "bg-green-100 text-green-800": this.alertType === "success",
        "bg-red-100 text-red-800": this.alertType === "dismiss",
      };
    },
  },
  methods: {
    dismissAlert() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.alert-container {
  /* width: 64%; */
  padding-right: 2.25rem;
  margin-left: 29px;
  margin-top: 12px;
}
</style>
